import React from 'react'

import { ViewTracker } from 'buyer-intent-sdk/react'

import { useBuyerIntentTrackingEnabled } from './BuyerIntentTrackingContext'
import ErrorBoundary from './ErrorBoundary'
import { hasBuyerIntentIdentifiers, normalizeBuyerIntentProps } from './normalizeProps'

const createBuyerIntentView = ({ displayName, tag }) => {
  /** @type {import("react").FC<{
   *  productId?: string | number | null,
   *  productIds?: Array<string | number | null>,
   *  categoryId?: string | number | null,
   *  categoryIds?: Array<string | number | null>,
   *  children?: import("react").ReactNode,
   *  sourceLocation?: string,
   *  context?: Record<string, unknown>,
   *  origin?: string,
   *  activityEndpoint?: string,
   *  userType?: string,
   *  distinctId?: string,
   * }>}
   */
  const BuyerIntentView = ({ children, productId, productIds, categoryId, categoryIds, ...rest }) => {
    const trackingEnabled = useBuyerIntentTrackingEnabled()
    const intentProps = normalizeBuyerIntentProps({
      productId,
      productIds,
      categoryId,
      categoryIds,
    })

    if (!trackingEnabled) {
      return <>{children}</>
    }

    if (!hasBuyerIntentIdentifiers(intentProps)) {
      return <>{children}</>
    }

    return (
      <ErrorBoundary fallback={<>{children}</>}>
        <ViewTracker {...rest} {...intentProps} tag={tag}>
          {children}
        </ViewTracker>
      </ErrorBoundary>
    )
  }

  BuyerIntentView.displayName = displayName

  return BuyerIntentView
}

export default createBuyerIntentView
